import React, { useContext } from 'react'
import * as Constantes from '../../../../utils/constantes'
import styles from '../../Identificacion.module.css'
import GeneralContext from '../../../../context/GeneralContext'
const RenderPersona = ({
  state,
  asegurado,
  contratante,
  documentos,
  handleChangeNumerico,
  handleChangeCombo,
  handleChangeBlur
}) => {
  const { state: generalState } = useContext(GeneralContext)
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  //Modo lectura
  let Deshabilitar = (complete) => {
    complete = cotizacion.edicionInhabilitada
    if (complete === true && complete !== undefined) {
      return true
    } else {
      return false
    }
  }

  const tamanioDocumento = (codigo) => {
    if (codigo !== null && codigo !== undefined) {
      return Constantes['CANTIDAD_DIGITOS_TIPO_DOCUMENTO_' + codigo]
    } else {
        return '0'
    }
  }

  return (
    <React.Fragment>
      <div className={`${styles['grupodeform']} ${styles['top18']}`}>
        <div>
          <label>Tipo de persona</label>
          <label className={styles.container}>Natural
            <input type="radio" defaultChecked name="radio" disabled={Deshabilitar() !== true ? false : true} />
            <span className={styles.checkmark}></span>
          </label>
        </div>
        <div className={styles['area20']}>
          <label>Tipo Doc.</label>
          <select
            className={!state.campoValidado.tipoDocumento ? `${styles['logerror']} ${styles['tipoDoc']}` : styles['tipoDoc']}
            value={asegurado !== undefined && asegurado.tipoDocumento
              ? asegurado.tipoDocumento.codigo
              : contratante !== undefined && contratante.tipoDocumento
                ? contratante.tipoDocumento.codigo
                : ''}
            onChange={(e) => handleChangeCombo(e, 'tipoDocumento')}
            disabled={Deshabilitar() !== true ? asegurado !== undefined
              ? asegurado.idAsegurado !== undefined
              : false : true}
          >
            <option value={0}>Seleccione</option>
            {documentos && documentos.length > 0 && documentos.map(documento => (
              <option key={documento.id} value={documento.id}>
                {documento.valor}
              </option>
            ))}
          </select>
          {!state.campoValidado.tipoDocumento &&
            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_TIP_DOCUMENTO}</span>
          }
        </div>
        <div className={styles['area30']}>
          <label style={{ marginLeft: '17%' }}>Nro. de Documento</label>
          <input
            type='text'
            className={!state.campoValidado.numeroDocumento ? styles['logerror'] : null}
            value={asegurado !== undefined
              ? asegurado.numeroDocumento || ''
              : contratante !== undefined
                ? contratante.numeroDocumento || ''
                : ''}
            maxLength={tamanioDocumento(contratante.tipoDocumento && contratante.tipoDocumento.codigo)}
            onChange={(e) => handleChangeNumerico(e, 'numeroDocumento', contratante.tipoDocumento.codigo)}
            onBlur={(e) => handleChangeBlur()}
            disabled={Deshabilitar() !== true ? asegurado !== undefined
              ? asegurado.idAsegurado !== undefined
              : false : true}
          />
          {!state.campoValidado.numeroDocumento &&
            <span className={styles['span-error']} style={{ marginLeft: '18%' }}>{Constantes.MENSAJE_VALIDACION_NUM_DOCUMENTO}</span>
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default RenderPersona
